import React from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import { RoundedImg } from 'components';
import Literal from 'components/literal';
import './styles.scss';

const DropzoneAccept = {
    'image/*': [],
};

const UploadPhoto = ({
    maxSize = 4194304,
    onChange = () => null,
    onError = () => null,
    value = '',
}) => {
    const onDropHandler = (files) => {
        if (files.length === 0) {
            onError();
            return;
        }
        const reader = new FileReader();

        reader.readAsDataURL(files[0]);
        reader.onload = () => {
            const base64 = reader.result.split('base64,');
            onChange(base64 && base64.length > 0 ? base64[1] : '');
        };

        reader.onerror = () => {
            onChange('');
            onError();
        };
    };

    const removePhoto = (event) => {
        event.stopPropagation();
        onChange('');
    };

    return (
        <Dropzone
            accept={DropzoneAccept}
            disableClick
            onDrop={(files) => onDropHandler(files)}
            multiple={false}
            maxSize={maxSize}
        >
            {({ getRootProps, getInputProps, isDragActive, open }) => {
                const classNames = ['upload-photo'];
                if (isDragActive) {
                    classNames.push('drag-active');
                }

                const hasFoto = value && value.length > 0;

                return (
                    <div
                        role="button"
                        tabIndex="-1"
                        {...getRootProps()}
                        className={classNames.join(' ')}
                        onClick={() => open()}
                    >
                        <input {...getInputProps()} />
                        {hasFoto ? (
                            <div className="upload-photo__img-container">
                                <RoundedImg
                                    className="upload-photo__img"
                                    alt=""
                                    src={`data:image/png;base64,${value}`}
                                    diameter={64}
                                    dismissible
                                    onClickDismissible={removePhoto}
                                />
                                <p className="upload-photo__img-text">
                                    <Literal literal="cfm_label_dran_and_drop" />{' '}
                                    <span className="text-blue">
                                        <Literal literal="cfm_label_dran_and_drop_and_update" />
                                    </span>
                                </p>
                            </div>
                        ) : (
                            <p className="upload-photo__empty-text">
                                <Literal literal="cfm_label_dran_and_drop" />{' '}
                                <span className="text-blue">
                                    <Literal literal="cfm_label_drag_and_drop_and_upload" />
                                </span>
                            </p>
                        )}
                        <div className="upload-photo__drop-message">
                            <Literal literal="cfm_label_drop_to_upload" />
                        </div>
                    </div>
                );
            }}
        </Dropzone>
    );
};

UploadPhoto.propTypes = {
    /* max size in bytes */
    maxSize: PropTypes.number,
    onChange: PropTypes.func,
    onError: PropTypes.func,
    value: PropTypes.string,
};

export default UploadPhoto;
